// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3xCdy","colMaxWidth":"Table_colMaxWidth__2EvVk"};